(function () {
  const elements = document.querySelectorAll('[data-blinky]');
  if (!elements.length) return;

  const projectItems = document.querySelectorAll('.project-list-item');
  let shouldBlink = !Array.from(projectItems).some((el) => el.classList.contains('is-active'));

  if (projectItems.length) {
    const observer = new MutationObserver((mutations) => {
      const target = mutations[0].target;
      const nowActive = target.classList.contains('is-active');
      if (nowActive && shouldBlink) {
        shouldBlink = false;
        elements.forEach((el) => el.classList.remove('is-blinky'));
      } else if (!nowActive && !shouldBlink) {
        // Re-check all items — another one might still be active
        shouldBlink = !Array.from(projectItems).some((el) => el.classList.contains('is-active'));
      }
    });
    projectItems.forEach((item) => {
      observer.observe(item, { attributes: true, attributeFilter: ['class'] });
    });
  }

  // Box-Muller transform for Gaussian random numbers
  function gaussian(mean, stdDev) {
    let u = 0, v = 0;
    while (u === 0) u = Math.random();
    while (v === 0) v = Math.random();
    const z = Math.sqrt(-2.0 * Math.log(u)) * Math.cos(2.0 * Math.PI * v);
    return z * stdDev + mean;
  }

  // Clamp to sensible range so outliers don't break the vibe
  function gaussianClamped(mean, stdDev, min, max) {
    return Math.max(min, Math.min(max, gaussian(mean, stdDev)));
  }

  function scheduleBlink(el) {
    // Time until next blink: mean 3s, wide spread → organic staggering
    const delay = gaussianClamped(3000, 1500, 400, 8000);

    setTimeout(() => {
      // How long the blink stays lit
      const duration = gaussianClamped(900, 350, 300, 2000);

      if (shouldBlink) {
        el.classList.add('is-blinky');
      }
      setTimeout(() => {
        el.classList.remove('is-blinky');
        scheduleBlink(el); // recurse with fresh randomness
      }, duration);
    }, delay);
  }

  elements.forEach((el) => {
    // Offset each element's start so they don't sync up
    setTimeout(() => scheduleBlink(el), Math.random() * 2000);
  });
})();
